var map = {
	"./About-Us-Header.jpg": 4092,
	"./FDA.png": 2249,
	"./banner.webp": 7267,
	"./font/iconfont.css": 5159,
	"./foot_bg.jpg": 2452,
	"./h02.jpg": 7044,
	"./h03.jpg": 1377,
	"./h04.jpg": 6770,
	"./h05.jpg": 4831,
	"./h2-1_01.jpg": 1192,
	"./h2-1_02.jpg": 9863,
	"./h2-1_03.jpg": 1578,
	"./h2-1_04.jpg": 7417,
	"./h2-1_05.jpg": 3276,
	"./h2-1_06.jpg": 6075,
	"./hk.jpg": 3803,
	"./synergy.webp": 9742,
	"./tiktok.png": 4934,
	"./vesitinLogo.webp": 2924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;